import {
  normalizeCryptoSwapError,
  type NormalizedCryptoSwapError,
  type NormalizeOptions,
} from "./cryptoSwapErrors";

const BREB_KEY_REQUIRED_CODE = "breb_key_required";
const QUOTE_UNAVAILABLE_CODE = "quote_unavailable";
export const SELL_ORDER_OPEN_CODE = "sell_order_open";

const GATEWAY_STATUSES: readonly number[] = [502, 503, 504];

/**
 * A sale's create errors read differently from a purchase's: an address is only ever shown from the saved
 * sale, so a 5xx the backend answered itself means nothing was shown and nothing can move. A lost response,
 * or a gateway/timeout status without the backend's own code, leaves it unknown.
 */
export function normalizeSellCreateError(
  error: unknown,
  options: NormalizeOptions = {},
): NormalizedCryptoSwapError {
  const normalized = normalizeCryptoSwapError(error, "orders_create", options);
  const status = normalized.status;
  const fromGateway = status !== null && GATEWAY_STATUSES.includes(status) && normalized.code === null;
  if (status !== null && status >= 500 && !fromGateway) {
    return { ...normalized, kind: "rejected", messageKey: "sell_error_not_created", retryable: false };
  }
  if (normalized.kind === "unconfirmed") return { ...normalized, messageKey: "sell_error_unconfirmed" };
  if (normalized.kind === "verification_required") {
    return { ...normalized, messageKey: "sell_error_verification_required" };
  }
  if (normalized.code === BREB_KEY_REQUIRED_CODE) {
    return { ...normalized, messageKey: "sell_error_breb_key_required" };
  }
  if (normalized.kind === "conflict") return { ...normalized, messageKey: "sell_error_conflict" };
  return normalized;
}

/** The desk quote behind ours is gone after these: only a new price can place the sale. */
export function isSellQuoteSpent(error: NormalizedCryptoSwapError): boolean {
  return (
    error.kind === "quote_expired" ||
    error.status === 422 ||
    (error.kind === "rejected" && error.status !== null && error.status >= 500) ||
    error.code === QUOTE_UNAVAILABLE_CODE
  );
}
